import Link from 'next/link';

export default function Header() {
  return (
    <header style={styles.header}>
      <Link href="/" style={styles.logo}>UstamGelsin</Link>

      <nav style={styles.nav}>
        <Link href="/hizmetler" style={styles.link}>Hizmetler</Link>
        <Link href="/nasil-calisir" style={styles.link}>Nasıl Çalışır?</Link>
        <Link href="/hakkimizda" style={styles.link}>Hakkımızda</Link>
        <Link href="/iletisim" style={styles.link}>İletişim</Link>
        <Link href="/basvuru" style={styles.button}>Kurucu Usta Ol</Link>
      </nav>
    </header>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    maxWidth: 1180,
    margin: '0 auto',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 20,
    flexWrap: 'wrap',
  },
  logo: {
    color: '#e85d3f',
    fontSize: 28,
    fontWeight: 900,
    textDecoration: 'none',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap',
  },
  link: {
    color: '#333',
    textDecoration: 'none',
    fontWeight: 600,
  },
  button: {
    background: '#e85d3f',
    color: 'white',
    padding: '11px 16px',
    borderRadius: 12,
    textDecoration: 'none',
    fontWeight: 800,
  },
};
